import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule, Provider } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CoreLibraryModule } from 'libs/core/src/lib/core-library.module';
import { ENVIRONMENT_TOKEN } from 'libs/core/src/lib/injection.tokens';
import { CoreComponent } from './component/core.component';
import { MainComponent } from './component/layout/main/main.component';
import { LoaderComponent } from './component/loading/loading.component';
import { PaymentMethodComponent } from './component/payment/proxy/component/payment-method/payment-method.component';
import { PaymentProxyComponent } from './component/payment/proxy/payment-proxy.component';
import { BasysPaymentProviderComponent } from './component/payment/proxy/provider/basys/basys-payment-provider.component';
import { HyperpayPaymentProviderComponent } from './component/payment/proxy/provider/hyperpay/hyperpay-payment-provider.component';
import { IntercardPaymentProviderComponent } from './component/payment/proxy/provider/intercard/intercard-payment-provider.component';
import { PayuBlikPaymentProviderComponent } from './component/payment/proxy/provider/payu-blik/payu-blik-payment-provider.component';
import { PayuPaymentProviderComponent } from './component/payment/proxy/provider/payu/payu-payment-provider.component';
import { SandboxPaymentProviderComponent } from './component/payment/proxy/provider/sandbox/sandbox-payment-provider.component';
import { WorldPayPaymentProviderComponent } from './component/payment/proxy/provider/worldpay/worldpay-payment-provider.component';
import { ProviderContainerComponent } from './component/tag-manager/provider-container/provider-container.component';
import { HomePageComponent } from './page/home/home.component';
import { WorldpayRedirectHubComponent } from './page/payment/worldpay-redirect-hub/worldpay-redirect-hub.component';
import { ScreeningPageComponent } from './page/screening/screening.component';
import { InternationalPhoneComponent } from './component/international-phone/international-phone.component';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { AppContributorComponent } from './component/app-contributor/app-contributor.component';
import { BackgroundComponent } from './component/order/background/background.component';
import { TagManagerComponent } from './component/tag-manager/tag-manager.component';
import { PopupComponent } from './component/popup/popup.component';
import { MessageComponent } from './component/message/message.component';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { DropdownComponent } from './component/ui/dropdown/dropdown.component';
import { TimeZoneTestPageComponent } from './page/test/tz.component';
import { LottieComponent, provideLottieOptions } from 'ngx-lottie';
import player from 'lottie-web';
import { ShareButtonsComponent } from './component/share-buttons/share-buttons.component';
import { shareIcons } from 'ngx-sharebuttons/icons';
import { VgCoreModule } from '@videogular/ngx-videogular/core';
import { VgControlsModule } from '@videogular/ngx-videogular/controls';
import { VgOverlayPlayModule } from '@videogular/ngx-videogular/overlay-play';
import { VgBufferingModule } from '@videogular/ngx-videogular/buffering';
import { VideoPlayerComponent } from './component/video-player/video-player.component';
import { TranslateModule } from '@ngx-translate/core';
import { ImdbComponent } from './component/imdb/imdb.component';
import { UserStatusComponent } from './component/user/user-status/status.component';
import { ConfirmModalComponent } from './component/modal/confirm-modal/confirm-modal.component';
import { AccountItemsComponent } from './component/account-items/account-items.component';
import { NgxMaskDirective, NgxMaskPipe, provideEnvironmentNgxMask, provideNgxMask } from 'ngx-mask';
import { DateComponent } from './component/ui/date-component/date-component.component';
import { TabsComponent } from './component/ui/tabs/tabs.component';
import { TabComponent } from './component/ui/tabs/tab/tab.component';
import { GiftCardOnlineComponent } from './component/gift-card/gift-card-online/gift-card-online.component';
import { GiftCardPhysicalComponent } from './component/gift-card/gift-card-physical/gift-card-physical.component';
import { NumericStepperComponent } from './component/ui/numeric-stepper/numeric-stepper.component';
import { NgxBootstrapSliderModule } from 'ngx-bootstrap-slider';
import { GiftCardPurchaseComponent } from './component/gift-card/gift-card-purchase/gift-card-purchase.component';
import { SimpleCountdownComponent } from './component/simple-countdown/simple-countdown.component';
import { CorvusPayPaymentProviderComponent } from './component/payment/proxy/provider/corvuspay/corvuspay-payment-provider.component';
import { CustomWhaleComponent } from './component/tag-manager/provider/blue-whale/blue-whale.components';
import { DatePickerComponent } from './component/ui/date-picker/date-picker.component';
import { FlagComponent } from './component/flag/flag.component';
import { PhoneComponent } from './component/ui/phone-component/phone-component.component';
import { PrintMovieDetailComponent } from './component/print-movie-detail/print-movie-detail.component';
import { RadioButtonComponent } from './component/ui/radiobutton/radiobutton.component';
import { FiservPaymentProviderComponent } from './component/payment/proxy/provider/fiserv/fiserv-payment-provider.component';
import { AgeRatingComponent } from './component/age-rating/age-rating.component';
import { CheckboxComponent } from './component/ui/checkbox/checkbox.component';
import { NestPayPaymentProviderComponent } from './component/payment/proxy/provider/nestpay/nestpay-payment-provider.component';
import { DateTimePickerComponent } from './component/ui/date-time-picker/date-time-picker.component';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { BridgePayPaymentProviderComponent } from './component/payment/proxy/provider/bridgepay/bridgepay-payment-provider.component';
import { SendBoxComponent } from './component/send-box/send-box.component';
import { HeadlineModule } from './module/headline/headline.module';
import { FormModule } from './module/form/form.module';
import { ScreenSeatsComponent } from './component/screen/seats/seats.component';
import { ScreenSeatsSeatComponent } from './component/screen/seats/component/seat/seat.component';
import { ScreenSeatsMultiSeatComponent } from './component/screen/seats/component/multiseat/multiseat.component';
import { FiservDevPaymentProviderComponent } from './component/payment/proxy/provider/fiservdev/fiservdev-payment-provider.component';
import { TodayTomorrowComponent } from './component/today-tomorrow/today-tomorrow.component';
import { P24PaymentProviderComponent } from './component/payment/proxy/provider/p24/p24-payment-provider.component';
import { StickyHeaderComponent } from './component/sticky-header/sticky-header.component';
import { NexiXPayPaymentProviderComponent } from './component/payment/proxy/provider/nexixpay/nexixpay-payment-provider.component';
import { AppTagComponent } from './component/app-tag/app-tag.component';
import { UITestComponent } from './component/test/test.component';
import { provideShareButtonsOptions } from 'ngx-sharebuttons';
import { ShareButton } from 'ngx-sharebuttons/button';
import { ZoomableModule } from './module/zoomable/zoomable.module';
import { ScreenMovieDetailsComponent } from './component/screen/movie/movie-details/movie-details.component';
import { PanZoomModule } from './module/pan-zoom/pan-zoom.module';
import { ButtonComponent } from './component/ui/button/button.component';
import { CapitalizePipe } from './pipe/capitalize.pipe';
import { SafePipe } from './pipe/safe.pipe';
import { JoinPipe } from './pipe/join.pipe';
import { BreakTextPipe } from './pipe/replace-new-line.pipe';
import { SortAndFilterPipe } from './pipe/sort-and-filter.pipe';
import { LegendPipe } from './pipe/legend.pipe';
import { TranslateSelectorPipe } from './pipe/translate-selector.pipe';
import { EncodeUriPipe } from './pipe/encode-uri.pipe';
import { TimeParsePipe } from './pipe/time-parse.pipe';
import { SortPipe } from './pipe/sort.pipe';
import { FilterCallbackPipe } from './pipe/filter-callback.pipe';
import { ImageGalleryComponent } from './component/image-gallery/image-gallery.component';
import { ListComponent } from './component/ui/list/list.component';
import { ListItemDefDirective } from './component/ui/list/list-item-def.directive';
import { ErrorPageComponent } from './page/error/error.component';
import { RequiredAsteriskPipe } from './pipe/required-asterisk.pipe';

export function playerFactory() {
  return player;
}

const PaymentProviderComponents = [
  PayuPaymentProviderComponent,
  P24PaymentProviderComponent,
  HyperpayPaymentProviderComponent,
  PayuBlikPaymentProviderComponent,
  BasysPaymentProviderComponent,
  IntercardPaymentProviderComponent,
  SandboxPaymentProviderComponent,
  WorldPayPaymentProviderComponent,
  CorvusPayPaymentProviderComponent,
  FiservPaymentProviderComponent,
  NestPayPaymentProviderComponent,
  BridgePayPaymentProviderComponent,
  FiservDevPaymentProviderComponent,
  NexiXPayPaymentProviderComponent
];

const UIComponents = [DateTimePickerComponent];

const StndaloneUIComponents = [
  DropdownComponent,
  RadioButtonComponent,
  CheckboxComponent,
  TabsComponent,
  TabComponent,
  DatePickerComponent,
  NumericStepperComponent,
  ButtonComponent,
  PhoneComponent,
  ListComponent
];

const TestComponents = [UITestComponent];

const Pipes = [
  CapitalizePipe,
  SafePipe,
  JoinPipe,
  BreakTextPipe,
  SortAndFilterPipe,
  LegendPipe,
  TranslateSelectorPipe,
  EncodeUriPipe,
  TimeParsePipe,
  SortPipe,
  FilterCallbackPipe,
  RequiredAsteriskPipe
];

@NgModule({
  declarations: [
    CoreComponent,
    HomePageComponent,
    ScreeningPageComponent,
    MainComponent,
    ProviderContainerComponent,
    LoaderComponent,
    WorldpayRedirectHubComponent,
    PaymentMethodComponent,
    PaymentProxyComponent,
    InternationalPhoneComponent,
    AppContributorComponent,
    BackgroundComponent,
    TagManagerComponent,
    PopupComponent,
    TimeZoneTestPageComponent,
    ShareButtonsComponent,
    VideoPlayerComponent,
    ImdbComponent,
    UserStatusComponent,
    ConfirmModalComponent,
    AccountItemsComponent,
    DateComponent,
    GiftCardPurchaseComponent,
    GiftCardOnlineComponent,
    GiftCardPhysicalComponent,
    SimpleCountdownComponent,
    CustomWhaleComponent,
    FlagComponent,
    PrintMovieDetailComponent,
    AgeRatingComponent,
    SendBoxComponent,
    ScreenSeatsComponent,
    ScreenSeatsSeatComponent,
    ScreenSeatsMultiSeatComponent,
    TodayTomorrowComponent,
    StickyHeaderComponent,
    AppTagComponent,
    ScreenMovieDetailsComponent,
    ErrorPageComponent,
    MessageComponent,
    ...UIComponents,
    ...PaymentProviderComponents,
    ...TestComponents,
    ...Pipes
  ],
  imports: [
    CommonModule,
    RouterModule,
    CoreLibraryModule,
    FormsModule,
    ReactiveFormsModule,
    BsDropdownModule,
    CollapseModule.forRoot(),
    VgCoreModule,
    VgControlsModule,
    VgOverlayPlayModule,
    VgBufferingModule,
    TranslateModule.forChild(),
    NgxMaskDirective,
    NgxMaskPipe,
    NgxBootstrapSliderModule,
    TimepickerModule,
    HeadlineModule,
    FormModule,
    LottieComponent,
    ShareButton,
    ZoomableModule,
    PanZoomModule,
    ImageGalleryComponent,
    ...StndaloneUIComponents,
    ListItemDefDirective
  ],
  exports: [
    MainComponent,
    ProviderContainerComponent,
    WorldpayRedirectHubComponent,
    PaymentProxyComponent,
    AppContributorComponent,
    BackgroundComponent,
    TagManagerComponent,
    PopupComponent,
    MessageComponent,
    LottieComponent,
    CollapseModule,
    ShareButtonsComponent,
    VideoPlayerComponent,
    ImdbComponent,
    UserStatusComponent,
    ConfirmModalComponent,
    DateComponent,
    GiftCardOnlineComponent,
    GiftCardPhysicalComponent,
    FlagComponent,
    AgeRatingComponent,
    SendBoxComponent,
    HeadlineModule,
    FormModule,
    ScreenSeatsComponent,
    ScreenSeatsSeatComponent,
    ScreenSeatsMultiSeatComponent,
    TodayTomorrowComponent,
    StickyHeaderComponent,
    AppTagComponent,
    ZoomableModule,
    PanZoomModule,
    ScreenMovieDetailsComponent,
    NgxMaskDirective,
    NgxMaskPipe,
    ImageGalleryComponent,
    ...UIComponents,
    ...TestComponents,
    ...StndaloneUIComponents,
    ...Pipes,
    ListItemDefDirective
  ]
})
export class SharedLibraryModule {
  public static forRoot(environment: any, providers: Provider[] = []): ModuleWithProviders<SharedLibraryModule> {
    return {
      ngModule: SharedLibraryModule,
      providers: [
        {
          provide: ENVIRONMENT_TOKEN,
          useValue: environment
        },
        provideLottieOptions({
          player: () => player
        }),
        provideNgxMask(),
        provideEnvironmentNgxMask(),
        provideShareButtonsOptions(shareIcons()),
        ...[providers]
      ]
    };
  }
}
